import { clsx } from 'clsx/lite'
import type { ComponentProps, ReactNode } from 'react'

export function Stat({
  stat,
  text,
  className,
  ...props
}: { stat: ReactNode; text: ReactNode } & ComponentProps<'div'>) {
  return (
    <div className={clsx('rounded-xl bg-mauve-950/2.5 p-6 dark:bg-white/5', className)} {...props}>
      <div className="text-2xl/10 tracking-tight text-mauve-950 dark:text-white">{stat}</div>
      <p className="mt-2 text-sm/7 text-mauve-700 dark:text-mauve-400">{text}</p>
    </div>
  )
}
